import {SCORES_TOGGLE_SKILL} from "../constants/actionTypes";

export const toggleSkill = (payload) => ({
  type: SCORES_TOGGLE_SKILL,
  payload,
});
